import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const ProjectService = {
    projectList,
    projectDetailsByID,
    createProject,
    updateProject,
    updateProjectStatus,
    deleteProject,
    drillingProjectDashboard,
    drillingWellDashboard,
    wellInfoMasterList,
    laqProjectDashboard,
    laqCategoryDashboard,
    HFCompletionProjectDashboard,
    HFCompletionWellDashboard,
    WorkoverProjectDashboard,
    WorkoverWellDashboard,
    ProductionProjectDashboard,
    ProductionWellDashboard,
    ClearanceDashboard,
    KMDashboard,
    ContractingDashboard,
    CWPDashboard,
    GISMapWellData,
    updateWellPrefix
}

async function projectList(type) {
    let url = '/project?sort[createdAt]=ASC'
    if (type) url = url + '&' + type
    try {
        const response = await RestMethod.GET(url);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function projectDetailsByID(id) {
    try {
        const response = await RestMethod.GET('/project/' + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function createProject(data) {
    try {
        const response = await RestMethod.POST('/project', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateProject(id, data) {
    try {
        const response = await RestMethod.PUT('/project/' + id, data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateProjectStatus(id) {
    try {
        const response = await RestMethod.PUT('/project/status/' + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateWellPrefix(id, data) {
    try {
        const response = await RestMethod.PUT('/project/well-prefix/' + id, data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function deleteProject(id) {
    try {
        const response = await RestMethod.DELETE('/project/' + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function drillingProjectDashboard(data) {
    try {
        const response = await RestMethod.POST('/project/drilling/project-dashboard', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function laqProjectDashboard(data) {
    try {
        const response = await RestMethod.POST('/project/laq/project-dashboard', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}
async function HFCompletionProjectDashboard(data) {
    try {
        const response = await RestMethod.POST('/project/hf-completion/project-dashboard', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function HFCompletionWellDashboard(data) {
    try {
        const response = await RestMethod.POST('/project/hf-completion/well-dashboard', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function drillingWellDashboard(data) {
    try {
        const response = await RestMethod.POST('/project/drilling/well-dashboard', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function wellInfoMasterList(id) {
    try {
        const response = await RestMethod.GET('/project/wellInfoMaster/' + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function laqCategoryDashboard(data) {
    try {
        const response = await RestMethod.POST('/project/laq/category-dashboard', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


/*********** Workover Dashboard ********/
async function WorkoverProjectDashboard(data) {
    try {
        const response = await RestMethod.POST('/project/workover/project-dashboard', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function WorkoverWellDashboard(data) {
    try {
        const response = await RestMethod.POST('/project/workover/well-dashboard', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

/*********** Production Dashboard ********/
async function ProductionProjectDashboard(data) {
    try {
        const response = await RestMethod.POST('/project/production/project-dashboard', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function ProductionWellDashboard(data) {
    try {
        const response = await RestMethod.POST('/project/production/well-dashboard', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

/*********** Regulatory Compliance Dashboard ********/
async function ClearanceDashboard(projectId, data) {
    try {
        const response = await RestMethod.POST("/dashboard/" + projectId + "/clearance-dashboard", data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function ContractingDashboard(projectId, data) {
    try {
        const response = await RestMethod.POST("/dashboard/" + projectId + "/contracting-dashboard", data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function CWPDashboard(projectId, data) {
    try {
        const response = await RestMethod.POST("/dashboard/" + projectId + "/cwp-dashboard", data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}
async function KMDashboard(projectId, data) {
    try {
        const response = await RestMethod.POST("/dashboard/" + projectId + "/km-dashboard", data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function GISMapWellData(projectId, id) {
    try {
        const response = await RestMethod.GET("/project/" + projectId + "/map-wellinfo-data/" + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}